import { useState, useEffect, useCallback } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import SuiTypography from "components/SuiTypography";

import toast from "react-hot-toast";
import ManufacturerList from "pages/de/manufacturer-list";
import qs from "query-string";

import api from "services/api";

const PublishProject = () => {
  const [detail, setDetail] = useState({});
  const [navUrl, setNavUrl] = useState("");
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [uploading, setUploading] = useState(false);

  let location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  const projectId = urlObj?.query?.id;

  const navigate = useNavigate();

  useEffect(() => {
    if (projectId) {
      retrieveProjectDetail(projectId);
    }
  }, [projectId]);

  const retrieveProjectDetail = async (id) => {
    try {
      const { data } = await api.project.get(urlObj?.query?.id);
      const project = data["project"] ? data["project"] : {};
      if (!project.id) {
        setNavUrl("/produce/all-projects", { replace: true });
      }
      setDetail(project);
    } catch (err) {
      setNavUrl("/produce/all-projects");
      console.log(err);
    }
  };

  const handleOk = async (selectedManufacturer, isPublic) => {
    const manufacturers = Object.keys(selectedManufacturer);
    //remove unchecked manufacturers
    let checkedManufacturers = [];
    for (let i = 0; i < manufacturers.length; i++) {
      if (selectedManufacturer[manufacturers[i]] == true) {
        checkedManufacturers.push(manufacturers[i]);
      }
    }

    const payload = {
      audiences: checkedManufacturers,
      visibility: isPublic == true ? "public" : "private",
    };

    try {
      setUploading(true);
      await api.project.update(detail.id, payload);
      const res = await api.project.updateStatus({ id: detail.id, status: "requested" });
      setTimeout(() => {
        setUploading(false);
        isPublic
          ? toast.success("Your Project has been successfully posted to all Manufacturers!")
          : toast.success("Your Project has been successfully sent!");
        navigate(`/produce/all-projects?id=${detail.id}`);
      }, 1500);
    } catch (err) {
      setUploading(false);
      isPublic
        ? toast.error("Your Project could not be posted to all Manufacturers!")
        : toast.error("Your Project could not be sent!");
      console.log(err);
    }
  };

  return (
    <div>
      {navUrl && <Navigate to={navUrl} />}

      {detail.id ? (
        <div>
          <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={uploading}>
            <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
            <SuiTypography variant="h6" fontWeight="medium" color="info">
              Processing...
            </SuiTypography>
          </Backdrop>
          <ManufacturerList
            handleOk={handleOk}
            handleOkText="Send Request"
            handleBackText={"Back"}
            selectable={true}
            project={detail}
          />
        </div>
      ) : null}
    </div>
  );
};
export default PublishProject;
